import { useLanguage } from "../i18n/LanguageContext";
import { useMeta } from "../hooks/useMeta";
import { PageHeader } from "../components/PageHeader";
import { LEGAL } from "../data/legal";

const hasPlaceholder = (text = "") => /\[[^\]]+\]/.test(text);
const CURRENT_EMAIL = "office@pilateson.de";
const OLD_EMAIL = "office@pilateson.de";
const withCurrentEmail = (text = "") => text.replaceAll(OLD_EMAIL, CURRENT_EMAIL);

// These company details are intentionally not published yet.
// They can be added back once the final legal identity is available.
const HIDDEN_LEGAL_HEADINGS = new Set([
  "Umsatzsteuer-ID",
  "Registereintrag",
  "Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV",
]);

export default function Legal({ slug }) {
  const { t } = useLanguage();
  const content = t.legal[slug];
  const sections = LEGAL[slug];
  const visibleSections = sections
    .filter((section) => !HIDDEN_LEGAL_HEADINGS.has(section.h))
    .map((section) => ({
      ...section,
      p: section.p
        .filter((para) => !hasPlaceholder(para))
        .map(withCurrentEmail),
    }))
    .filter((section) => section.p.length > 0);

  useMeta(`${content.title.join(" ")} — PILATES ON.`, visibleSections[0]?.p[0]?.slice(0, 150) || "PILATES ON.");

  return (
    <div data-testid={`legal-${slug}`}>
      <PageHeader id={`legal-${slug}`} overline="PILATES ON." lines={content.title} />
      <div className="mx-auto max-w-[900px] px-6 pb-32 md:px-12">
        <div className="space-y-12">
          {visibleSections.map((s) => (
            <section key={s.h} data-testid="legal-section">
              <h2 className="font-serif text-2xl font-light text-[#1C1C1A] md:text-3xl">{s.h}</h2>
              {s.p.map((para) => (
                <p key={para.slice(0, 40)} className="mt-4 whitespace-pre-line text-[15px] font-light leading-relaxed text-[#66625A]">
                  {para}
                </p>
              ))}
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}
